module.exports = __webpack_public_path__ + "media/images/pic/activities/tokio-7bc26eac1fdfae80f25df8168b138d9c.png";